module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('div', {
    staticClass: "box__caption"
  }, [_vm._v("Live")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm._f("formatDateFromNow")(_vm.item.started_at)))])]), _vm._v(" "), _c('div', {
    staticClass: "box__content"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v(_vm._s(_vm._.get(_vm.item, "user.username")))]), _vm._v(" "), _c('div', {
    staticClass: "box__subtitle"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm._.get(_vm.item, "genre.name")))])]), _vm._v(" "), (_vm.item.view_price > 0) ? _c('div', {
    staticClass: "box__footer"
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "to": ("/" + (_vm._.get(_vm.item, 'user.slug')))
    }
  }, [_vm._v("Watch")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eac36f80","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/video_detail_box.vue
// module id = 1860
// module chunks = 180